import * as React from 'react';
import * as Datetime from 'jonshort-shim-react-bootstrap-date-picker';
import DatePicker from 'react-date-picker';
import { format } from 'date-fns';
import { formatterDate } from '../../helpers/FormatterDate';

interface DateTimeProps {
  value?: string;
  disabled: boolean;
  label?: string;

  maxDate?: string;
  minDate?: string;
  placeholder?: string;
  ignoreTitle?: boolean;
  onFocus?: () => void;
  onBlur?: () => void;
  onChangeValue: (value: string) => void;
  style?: any;
  valueType?: string | undefined;
}

interface DateTimeState {
  open: boolean;
}

const calendarProperties: Partial<Record<string, unknown>> = {
  year: {
    format: 'y',
    maxDetail: 'decade',
  },
  default: {
    format: 'dd.MM.y',
  },
};

class DateTime extends React.Component<DateTimeProps, DateTimeState> {
  // eslint-disable-next-line react/no-unused-class-component-methods
  private date: Datetime;

  onChange = value => {
    if (value) {
      value = format(new Date(value), 'dd.MM.yyyy');
    }

    this.props.onChangeValue(value);
    // if (this.props.maxDate && isMaxDate(this.props.maxDate, value) &&
    //     this.props.minDate && isMinDate(this.props.minDate, value)) {
    //   this.props.onChangeValue(value ?? "");
    // } else if (!this.props?.maxDate || !this.props?.minDate) {
    //   if (this.props?.maxDate && isMaxDate(this.props.maxDate, value)) {
    //     this.props.onChangeValue(value ?? "");
    //   } else if (this.props?.minDate && isMinDate(this.props.minDate, value)){
    //     this.props.onChangeValue(value ?? "");
    //   } else {
    //     if (!this.props?.maxDate && !this.props?.minDate) {
    //       this.props.onChangeValue(value ?? "");
    //     } else {
    //       this.props.onChangeValue("");
    //     }
    //   }
    // } else {
    //   this.props.onChangeValue("");
    // }
  };

  render() {
    const control = (
      <DatePicker
        inputRef={date => {
          // TODO: Type REF
          // eslint-disable-next-line react/no-unused-class-component-methods
          this.date = date;
        }}
        value={formatterDate(this.props.value)}
        maxDate={formatterDate(this.props.maxDate)}
        minDate={formatterDate(this.props.minDate)}
        onChange={this.onChange}
        disabled={this.props.disabled}
        className="form-control"
        // @ts-ignore
        {...calendarProperties?.[this.props?.valueType || 'default']}
      />
    );

    return !this.props?.ignoreTitle ? (
      <div
        className="form-group"
        style={{ marginLeft: '0px', marginRight: 0, ...this.props.style }}
      >
        {this.props.label && (
          <label className="control-label">{this.props.label}</label>
        )}
        <span className="input-group">{control}</span>
      </div>
    ) : (
      control
    );
  }
}

export default DateTime;
